<template>
    <div>
        <h1 style="font-size: 24px; color: black;">商品配置</h1>
        <div style="margin-bottom: 10px;">
            <el-button  type="primary" @click="showDetails('新增板块')">新增</el-button>
        </div>
        <h1>
        <el-table border
                  :data="ruleList">
            <el-table-column  label="版块编号" prop="id"  ></el-table-column>
            <el-table-column  label="版块名称" prop="name"  ></el-table-column>
            <el-table-column  label="开关"   >
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.state"
                               :active-value="1"
                               :inactive-value="0"
                               active-text="开启"
                               inactive-text="关闭"
                               @change="update(scope.row)">
                    </el-switch>
                </template>
            </el-table-column>
            <el-table-column  label="操作"  align="center">
                <template slot-scope="scope">
                    <el-button  plain size="mini" type="primary" @click="showDetails('编辑板块',scope.row)">编辑</el-button>
                </template>
            </el-table-column>
            <el-table-column  label="选品"  align="center">
                <template slot-scope="scope">
                <el-button  plain size="mini" type="success" @click="goodSelect(scope.row)">去管理</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-dialog :title="dialogTitle" center :visible.sync="dialogVisible" width="600px">
                <el-form :model="ruleEditForm" label-width="150px">
                    <el-form-item label="版块名称:" >
                        <el-input  style="width: 300px" type="text" v-model="ruleEditForm.name"></el-input>
                    </el-form-item>
                    <el-form-item label="是否展示:" >
                        <el-radio-group v-model="ruleEditForm.state">
                            <el-radio :label="1">展示</el-radio>
                            <el-radio :label="0">不展示</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <div style="text-align: center;">
                        <el-button type="primary" @click="confirm">确 定</el-button>
                        <el-button type="info" @click="cancel">取 消</el-button>
                    </div>
                </el-form>
            </el-dialog>
        </h1>
    </div>
</template>

<script>
    import {
        listExchangeRule,
        saveExchangeRule
    }from "@/http/api";
    export default {
        name: "GoodsConfig",
        data(){
            return{
                ruleList:[],
                dialogVisible: false,
                dialogTitle :'',
                ruleEditForm: {},
            }
        },
        methods:{
            showDetails(title, row) {
                this.ruleEditForm = {
                    "id" : 0,
                    "name" :'',
                    "state" : 0,
                };

                this.dialogTitle = title;
                this.dialogVisible = true;

                if(row){
                    this.ruleEditForm = {
                        "id" : row.id,
                        "name" :row.name,
                        "state" : row.state,
                    };
                }
            },
            confirm(){
                saveExchangeRule(this.ruleEditForm).then(resp=> {
                    if (resp.data.status===0){
                        this.dialogVisible = false;
                        this.queryList();
                    }
                })
            },
            cancel(){
                this.dialogVisible=false;
            },
            update(row){
                this.ruleEditForm = {
                    "id" : row.id,
                    "name" :row.name,
                    "state" : row.state,
                };
                saveExchangeRule(this.ruleEditForm).then(resp=> {
                    if (resp.data.status===0){
                        this.dialogVisible = false;
                        this.queryList();
                    }
                })
            },
            queryList(){
                listExchangeRule().then(resp=>{
                    this.ruleList=resp.data.info;
                });
            },
            goodSelect(exchangeRule){
                this.$store.commit('exchange', exchangeRule);
                this.$router.push({ path: '/selectGood'});
            }
        },
        created() {
            this.queryList();
        }
    }
</script>

<style scoped>

</style>